import { arcadeEn } from "./arcade.en.ts";
import { translate, type Translation } from "./lang.ts";

/**
 * Máy Gắp Lém Lỉnh copy (Fun Arcade). Same house style as vi.ts:
 * warm and plain, no dashes, dots, slashes, symbols or parentheses.
 * English twin in `arcade.en.ts`.
 */
const source = {
  coins: (n: number) => `Đã thả ${n} xu`,
  hintCost: "Xài gợi ý thì màn này tối đa 2 sao thôi đó. Vẫn xài hông?",
  stuck: "Vách kính chặn mất đường về của bạn thú rồi. Hoàn tác vài xu hoặc chơi lại nha.",
  resultCoins: (n: number, best: number) =>
    n <= best ? `Bạn gắp hết ${n} xu, gọn y như lời giải đẹp nhất!` : `Bạn gắp hết ${n} xu, lời giải gọn nhất chỉ tốn ${best} xu.`,
  resultRule: (three: number, two: number) => `Ba sao khi tốn không quá ${three} xu, hai sao khi không quá ${two} xu.`,
  resultHint: "Có xài gợi ý nên tối đa 2 sao nha.",
};

export type ArcadeStrings = Translation<typeof source>;

export const arcadeVi: ArcadeStrings = translate(source, arcadeEn);
